export const FillMethods = {
  shipping: 1,
  fulfillment: 2,
};
